import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import { useGetUser } from '../../hooks/useGetUser';
/////////////////////////////
// redux
import { useDispatch } from "react-redux"
import {
  showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';

import services from '../../services';

import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import PasswordStrength from '../../components/PasswordStrength';
import ModalLoading from '../../components/ModalLoading';
import AcoesUser from '../../components/ButtonsAcoes';

import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonChecked from "@material-ui/icons/RadioButtonChecked";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import styles from './styles.module.scss'

const MeusDados = ({ formPage, action, changes, indicarErros }) => {
  const dispatch = useDispatch();
  const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  const showMsgS = (msg) => dispatch(showMsgSAction(msg));

  const [perfis, setPerfis] = useState([])
  const [estados, setEstados] = useState([])
  const [cidades1, setCidades1] = useState([])
  const [cidades2, setCidades2] = useState([])

  const [modalLoading, setModalLoading] = useState(false);
  const [permiteAdicionarAlterarParticipante, setPermiteAdicionarAlterarParticipante] = useState(false);

  const history = useHistory()
  const user = useGetUser();

  useEffect(() => {
    getCidades1()
  }, [formPage.uf1]);

  useEffect(() => {
    getCidades2()
  }, [formPage.uf2]);

  useEffect(() => {
    getPerfis()
    getEstados()
  }, []);

  useEffect(() => {
    const claimAlterar = services.storage.getClaimValues("Participantes", "Alterar");
    const claimAdicionar = services.storage.getClaimValues("Participantes", "Cadastrar");
    var adicionaAltera = false;

    const acao = new URLSearchParams(history.location.search).get("acao")

    if((claimAdicionar && acao === 'I')|| (claimAlterar && acao === 'A'))
        adicionaAltera = true;

    setPermiteAdicionarAlterarParticipante(adicionaAltera);

  }, [permiteAdicionarAlterarParticipante]);

  const getPerfis = () => {
    trackPromise(
      services.apiAuto.perfisParticipantes()
        .then(res => {
          if (!res.fail) {
            setPerfis(res.data)
          } else {
            showMsgE(res.errors ? res.errors.message : 'Erro')
          }
        }).catch(error => {
          showMsgE(error.errors.length ? error.errors[0].message : 'Error')
        })
    )
  }

  const getEstados = () => {
    trackPromise(
      services.apiAuto.enderecoEstados()
        .then(res => {
          if (!res.fail) {
            setEstados(res.data)
          } else {
            showMsgE(res.errors ? res.errors.message : 'Erro')
          }
        }).catch(error => {
          showMsgE(error.errors.length ? error.errors[0].message : 'Error')
        })
    )
  }

  const getend1 = (value) => {
    if (services.validate.validateCep(value)) {
      trackPromise(
        services.apiAuto.enderecoEndByCep(value)
          .then(res => {
            if (res.data) {
              if (res.data.bairro) { changes(res.data.bairro, 'bairro1') }
              if (res.data.logradouro) { changes(res.data.logradouro, 'logradouro1') }
              if (res.data.uf) { changes(res.data.uf.ufId, 'uf1') }
              if (res.data.cidade) { changes(res.data.cidade.cidadeId, 'cidade1') }
            } else {
              showMsgE(res.errors ? res.errors.message : 'Erro')
            }
          }).catch(error => {
            showMsgE(error.errors.length ? error.errors[0].message : 'Error')
          })
      )
    }

    changes(value, 'cep1')
  }

  const getend2 = (value) => {
    if (services.validate.validateCep(value)) {
      trackPromise(
        services.apiAuto.enderecoEndByCep(value)
          .then(res => {
            if (res.data) {
              if (res.data.bairro) { changes(res.data.bairro, 'bairro2') }
              if (res.data.logradouro) { changes(res.data.logradouro, 'logradouro2') }
              if (res.data.uf) { changes(res.data.uf.ufId, 'uf2') }
              if (res.data.cidade) { changes(res.data.cidade.cidadeId, 'cidade2') }
            } else {
              showMsgE(res.errors ? res.errors.message : 'Erro')
            }
          }).catch(error => {
            showMsgE(error.errors.length ? error.errors[0].message : 'Error')
          })
      )
    }

    changes(value, 'cep2')
  }

  const getCidades1 = () => {
    if (formPage.uf1) {
      trackPromise(
        services.apiAuto.enderecoCidades(formPage.uf1)
          .then(res => {
            if (!res.fail) {
              setCidades1(res.data)
            } else {
              showMsgE(res.errors ? res.errors.message : 'Erro')
            }
          }).catch(error => {
            showMsgE(error.errors.length ? error.errors[0].message : 'Error')
          })
      )
    } else {
      setCidades1([])
    }
  }

  const getCidades2 = () => {
    if (formPage.uf2) {
      trackPromise(
        services.apiAuto.enderecoCidades(formPage.uf2)
          .then(res => {
            if (!res.fail) {
              setCidades2(res.data)
            } else {
              showMsgE(res.errors ? res.errors.message : 'Erro')
            }
          }).catch(error => {
            showMsgE(error.errors.length ? error.errors[0].message : 'Error')
          })
      )
    } else {
      setCidades2([])
    }
  }

  const changeEnderecoSim = (e) => {
    if (e.target.checked) {
      changes(true, 'mesmoEnderecoEntrega')
      formPage.mesmoEnderecoEntrega = true
    }
  }

  const changeEnderecoNao = (e) => {
    if (e.target.checked) {
      changes(false, 'mesmoEnderecoEntrega')
      formPage.mesmoEnderecoEntrega = false
    }
  }

  const parceiroId = new URLSearchParams(history.location.search).get("parceiro")
  const userId = new URLSearchParams(history.location.search).get("participante")
  const status = new URLSearchParams(history.location.search).get("status")

  const ativarInativar = async () => {
    setModalLoading(true)
    await services.apiAuto.adminstradorAtivarInativar(userId)
    setModalLoading(false)
    history.push(`/parceiros/detalhes?parceiro= ${parceiroId}`)
  }

  return (
    <div className={styles.wrapper}>
      {/* <div className="container MeusDados"> */}
      <div className={styles.title}>
        Participante
        <button className={styles.backButton} onClick={() => { history.goBack() }}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>
      <div className={styles.blueBackground}>
        <div className={styles.content}>
          <div className={`${styles.card} ${styles.white}`}>
            <div className={styles.subTitle}>
              Dados de pessoa física
            </div>

            <FormControl className={styles.half}>
              <TextField label="Nome Completo" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'nome')}
                value={formPage.nome}
                helperText={indicarErros && !formPage.nome && 'Campo obrigatório'}
                error={indicarErros && !formPage.nome ? true : false}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="CPF" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'userName')}
                value={services.mask.cpf(formPage.userName)}
                helperText={indicarErros && !formPage.userName && 'Campo obrigatório'}
                error={indicarErros && !formPage.userName ? true : false}
                variant="filled"
                disabled={formPage.userId}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="E-mail" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'email')}
                value={formPage.email}
                helperText={indicarErros && !formPage.email && 'Campo obrigatório'}
                error={indicarErros && !formPage.email ? true : false}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="Celular" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'phoneNumber')}
                value={services.mask.celphone(formPage.phoneNumber)}
                helperText={indicarErros && !formPage.phoneNumber && 'Campo obrigatório'}
                error={indicarErros && !formPage.phoneNumber ? true : false}
                variant="filled" inputProps={{ maxLength: 15 }}
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="Cargo" select size="small" className="customFilledInput"
                onChange={e => { changes(e.target.value, 'roleId') }}
                value={formPage.roleId}
                helperText={indicarErros && !formPage.roleId && 'Campo obrigatório'}
                error={indicarErros && !formPage.roleId ? true : false}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              >
                {perfis.map((option) => (
                  <MenuItem key={option.roleId} value={option.displayName}>
                    {option.displayName}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
            <div className={styles.subTitle}>
              Endereço
            </div>

            <FormControl className={styles.half}>
              <TextField label="CEP" type="text" size="small" className="customFilledInput"
                onChange={e => getend1(e.target.value, 'cep1')}
                value={services.mask.cep(formPage.cep1)}
                variant="filled"
                inputProps={{ maxLength: 9 }}
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="Logradouro" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'logradouro1')}
                value={formPage.logradouro1}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="Número" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'numero1')}
                value={formPage.numero1}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="Complemento" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'complemento1')}
                value={formPage.complemento1}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>
            <FormControl className={styles.half}>
              <TextField label="Bairro" type="text" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'bairro1')}
                value={formPage.bairro1}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              />
            </FormControl>

            <FormControl className={styles.half}>
              <TextField label="Estado" select size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'uf1')}
                value={formPage.uf1}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              >
                {estados.map((option) => (
                  <MenuItem key={option.ufId} value={option.ufId}>
                    {option.sigla}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>

            <FormControl className={styles.half}>
              <TextField label="Cidade" select size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'cidade1')}
                value={formPage.cidade1}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante}
              >
                {cidades1.map((option) => (
                  <MenuItem key={option.cidadeId} value={option.cidadeId}>
                    {option.nome}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>

            <div>
              Deseja usar o mesmo endereço para entrega?
              <div className={styles.wrapperUsarEnderecoEntrega}>
                <FormControlLabel value={formPage.mesmoEnderecoEntrega} control={
                  <Checkbox style={{ color: '#5CCBE1' }}
                    checked={formPage.mesmoEnderecoEntrega}
                    onChange={changeEnderecoSim}
                    disabled={!permiteAdicionarAlterarParticipante}
                  />
                } label="Sim" className={styles.radioOptions} />
                <FormControlLabel value={!formPage.mesmoEnderecoEntrega} control={
                  <Checkbox style={{ color: '#5CCBE1' }}
                    checked={!formPage.mesmoEnderecoEntrega}
                    onChange={changeEnderecoNao}
                    disabled={!permiteAdicionarAlterarParticipante}
                  />
                } label="Não" className={styles.radioOptions} />
              </div>
            </div>

            {(!formPage.mesmoEnderecoEntrega) && (<>
              <div className={formPage.mesmoEnderecoEntrega && "hide"}>
                <div className={styles.subTitle}>
                  Endereço de entrega
                </div>
                <FormControl>
                  <TextField label="CEP" type="text" size="small" className="customFilledInput"
                    onChange={e => getend2(e.target.value)}
                    value={services.mask.cep(formPage.cep2)}
                    variant="filled"
                    inputProps={{ maxLength: 9 }}
                    disabled={!permiteAdicionarAlterarParticipante} />
                </FormControl>
                <FormControl>
                  <TextField label="Logradouro" type="text" size="small" className="customFilledInput"
                    onChange={e => changes(e.target.value, 'logradouro2')}
                    value={formPage.logradouro2}
                    variant="filled" 
                    disabled={!permiteAdicionarAlterarParticipante} />
                </FormControl>
                <FormControl>
                  <TextField label="Número" type="text" size="small" className="customFilledInput"
                    onChange={e => changes(e.target.value, 'numero2')}
                    value={formPage.numero2}
                    variant="filled"
                    disabled={!permiteAdicionarAlterarParticipante} />
                </FormControl>
                <FormControl>
                  <TextField label="Complemento" type="text" size="small" className="customFilledInput"
                    onChange={e => changes(e.target.value, 'complemento2')}
                    value={formPage.complemento2}
                    variant="filled"
                    disabled={!permiteAdicionarAlterarParticipante} />
                </FormControl>
                <FormControl>
                  <TextField label="Bairro" type="text" size="small" className="customFilledInput"
                    onChange={e => changes(e.target.value, 'bairro2')}
                    value={formPage.bairro2}
                    variant="filled"
                    disabled={!permiteAdicionarAlterarParticipante} />
                </FormControl>

                <FormControl>
                  <TextField label="Estado" select size="small" className="customFilledInput"
                    onChange={e => changes(e.target.value, 'uf2')}
                    value={formPage.uf2}
                    variant="filled"
                    disabled={!permiteAdicionarAlterarParticipante}
                  >
                    {estados.map((option) => (
                      <MenuItem key={option.ufId} value={option.ufId}>
                        {option.sigla}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>

                <FormControl>
                  <TextField label="Cidade" select size="small" className="customFilledInput"
                    onChange={e => changes(e.target.value, 'cidade2')}
                    value={formPage.cidade2}
                    variant="filled"
                    disabled={!permiteAdicionarAlterarParticipante}
                  >
                    {cidades2.map((option) => (
                      <MenuItem key={option.cidadeId} value={option.cidadeId}>
                        {option.nome}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </div>
            </>)
            }
            <FormControl>
              <TextField label="Senha" type="password" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'senha')}
                value={formPage.senha}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante} />
            </FormControl><PasswordStrength password={formPage.senha} /><FormControl>
              <TextField label="Confirmar Senha" type="password" size="small" className="customFilledInput"
                onChange={e => changes(e.target.value, 'senhaConfirmar')}
                value={formPage.senhaConfirmar}
                variant="filled"
                disabled={!permiteAdicionarAlterarParticipante} />
            </FormControl>
          </div>
        </div>
        
        {
          permiteAdicionarAlterarParticipante ? (
            <div className={styles.blueBackground}>
            <div className={styles.content}>
              <div className={styles.card}>
  
                {<AcoesUser status={status}
                            key={user.userId}
                            encerrar={ativarInativar}
                            enviar={action}
                            disabled={false}
                            msgDialog={'Deseja cancelar esta ação? Todos os dados não salvos serão perdidos.'}
                            redirect={`/parceiros/detalhes?parceiro= ${parceiroId}`}
                            claimName={'Responsaveis'}
                />}
              </div>
            </div>
          </div>            
          ) : null
        }
        <ModalLoading
          open={modalLoading}
          size="lg"
        />
      </div>
    </div>
  );
}

export default MeusDados;